module.exports = __webpack_public_path__ + "static/media/lg-cirque-du-celest-3.aaa0099e.jpg";